<template>
  <Menu :open-names="openNames" @on-select="selectMenuNav" theme="light" ref="leftMenu"
    class="distributor-menu" :active-name="activeName">
    <sub-menu :subMenuDate="menuData"></sub-menu>
  </Menu>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import distributorMenu from '@/config/menu/distributor';
import subMenu from '@/components/layout/menu/subMenu';
import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import {commonLocalStorage, commonSessionStorage, hideAlibabaDistributorsMenuData} from "@/utils/common";

export default {
  mixins: [Mixin],
  data() {
    return {
      menuData: null,
      openNames: [], // 展开name 默认全展示
      activeName: '', // 默认第一个
      hideActiveNamePath: ['/newsList', '/newsListDetails'],
      isAdmin: this.$store.state.isAdmin, // 管理员
      webSocketListenerKey: '',
    };
  },
  computed: {
    isListing() {
      let value = false;
      let erpConfig = commonSessionStorage.getItem('erpConfig') || this.$store.state.erpConfig;
      if (erpConfig) {
        value = erpConfig.merchant.listingStatus === '1';
      }
      return value;
    },
  },
  created() {
    this.initWebSocket();
    this.setMenuData();
  },
  beforeDestroy() {
    this._isDestroyed = true;
  },
  methods: {
    setMenuId(menuData) {
      /**
       * @Description: 给带单设置name id
       * @author gan
       * @date: 2020/12/17 13:42
       * @params:
       */
      if (!menuData) return [];
      let v = this;

      function setId(data, id) {
        data = data.filter(i => !i.menuHide);
        data.forEach((i, j) => {
          if (id) {
            i.id = id + '-' + j;
          } else {
            i.id = j + '';
          }
          if (!v.activeName && !i.children) {
            if (v.hideActiveNamePath.indexOf(v.$route.path) <= -1) {
              v.activeName = i.id;
            }
          }
          if (v.$route.path === i.path) {
            if (v.hideActiveNamePath.indexOf(v.$route.path) <= -1) {
              v.activeName = i.id;
            }
          } else {
            let name = localStorage.getItem('distributorActiveName');
            if (name) {
              if (v.hideActiveNamePath.indexOf(v.$route.path) <= -1) {
                v.activeName = name;
              }
            }
          }
          localStorage.setItem('distributorActiveName', v.activeName);
          v.openNames.push(i.id);
          if (i.children && i.children.filter(k => !k.menuHide).length > 0) {
            i.children = setId(i.children, i.id);
          } else {
            i.children = null;
          }
        });
        return data;
      }

      return setId(menuData);
    },
    selectMenuNav(name) {
      this.activeName = name;
      localStorage.setItem('distributorActiveName', name);
    },
    setMenuData() {
      let distributorMenuData = JSON.parse(JSON.stringify(distributorMenu.menu));
      let menu = JSON.parse(JSON.stringify(distributorMenuData));
      let href = window.location.href;
      // 过滤掉商城的菜单
      let hideShopMenu = menu.filter((item) => {
        return item.type !== 'ymsShopping'
      });
      // 如果当前分销商是阿里国际分销，需要过滤掉相关菜单
      let menuData = hideAlibabaDistributorsMenuData(hideShopMenu);
      let distributor = this.setListingPath(menuData);
      if (href.includes('distributor.html')) {
        if (this.isAdmin) {
          this.menuData = this.setMenuId(distributor);
          this.updateMenu(this.$route.path);
          commonLocalStorage.setItem('pagesPermissions', this.menuData)
        } else {
          this.handlerNoPermission(distributor);
        }
      }
    },
    // 设置上架工具地址
    setListingPath(menu) {
      menu.forEach(j => {
        if (j.children) {
          j.children.forEach(i => {
            if (i.type === 'toListing') {
              i.name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000007');
              if (this.isListing) {
                i.name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000008');
              }
            }
          });
        }
      });
      return menu;
    },
    // 路由变化的时候，匹配选中指定的菜单
    updateMenu(path) {
      let v = this;
      let menuData = [];
      if (v.menuData) {
        if (!path.includes('Details')) {
          v.activeName = null;
        }

        function handerMenu(menu) {
          menu.forEach((item) => {
            if (item.children && item.children.length > 0) {
              handerMenu(item.children);
            } else {
              menuData.push(item);
            }
          });
        }

        handerMenu(v.menuData);
        if (menuData) {
          let pathArr = ['/modifyMobile', '/modifyMailbox', '/securityInformation'];
          menuData.map((item) => {
            if (pathArr.includes(path)) {
              if (item.path === '/securityInformation') {
                v.activeName = item.id;
                localStorage.setItem('distributorActiveName', item.id);
                v.$nextTick(function () {
                  v.$refs.leftMenu.updateOpened();
                  v.$refs.leftMenu.updateActiveName();
                });
              }
            } else {
              if (item.path === path) {
                v.activeName = item.id;
                localStorage.setItem('distributorActiveName', item.id);
                v.$nextTick(function () {
                  v.$refs.leftMenu.updateOpened();
                  v.$refs.leftMenu.updateActiveName();
                });
              } else {
                v.activeName = localStorage.getItem('distributorActiveName');
                v.$nextTick(function () {
                  v.$refs.leftMenu.updateOpened();
                  v.$refs.leftMenu.updateActiveName();
                });
              }
            }
          });
        }
        v.getMenuPendingData()
      }
    },
    // 处理过滤掉没有权限的树状数据
    handerMenuData(data, roleData) {
      if (data) {
        for (let i = data.length - 1; i >= 0; i--) {
          if (data[i].children && !data[i].children[0].menuHide) {
            let arr = [];
            data[i].children.filter((ele) => {
              if (roleData.indexOf(ele.menuKey) > -1) {
                arr.push(ele);
              }
            });
            data[i].children = arr;
            if (data[i].children.length <= 0) {
              data.splice(i, 1);
            }
          } else {
            if (!data[i].jurisdictionHide) {
              if (roleData.indexOf(data[i].menuKey) <= -1) {
                data.splice(i, 1);
              }
            }
          }
        }
        return data;
      }
    },
    // 过滤掉没有权限的菜单
    handlerNoPermission(menuData) {
      let v = this;
      let roleData = v.$store.state.roleData || commonLocalStorage.getItem('roleData');
      if (roleData) {
        function leftMenu(menu) {
          menu.forEach((item) => {
            if (item.children && item.children.length > 0) {
              v.handerMenuData(item.children, roleData);
            }
          });
        }

        leftMenu(menuData);
        if (menuData) {
          for (let i = menuData.length - 1; i >= 0; i--) {
            if (menuData[i].menuKey) {
              if (!menuData[i].jurisdictionHide) {
                if (roleData.indexOf(menuData[i].menuKey) <= -1) {
                  menuData.splice(i, 1);
                }
              }
            } else {
              if (menuData[i].children) {
                if (menuData[i].children.length <= 0) {
                  menuData.splice(i, 1);
                }
              }
            }
          }
          v.menuData = this.setMenuId(menuData);
          v.updateMenu(this.$route.path);
          v.$forceUpdate();
          commonLocalStorage.setItem('pagesPermissions', v.menuData)
        }
      }
    },
    /**
     * 注册分销商左侧菜单待办数量使用的 websocket 监听。
     */
    initWebSocket() {
      let v = this;
      if (!v.$webSocket.initWebSocket()) {
        return;
      }
      v.webSocketListenerKey = `distributor-left-${v._uid}`;
      v.$webSocket.subscribeMessage(v.webSocketListenerKey, (e) => {
        const data = v.$webSocket.parseMessage(e);
        if (data && data.type === 'pending') {
          v.getMenuPendingData(true);
        }
      }, v);
    },

    /**
     * 清理当前分销商左侧菜单注册的 websocket 监听。
     */
    clearWebSocketListener() {
      if (!this.webSocketListenerKey) return;
      this.$webSocket.unsubscribeMessage(this.webSocketListenerKey);
      this.webSocketListenerKey = '';
    },
    // 获取菜单栏待处理的数量的数据
    getMenuPendingData(value) {
      let v = this;
      if (value) {
        handleData();
      } else {
        let menuPendingCountData = commonSessionStorage.getItem('menuPendingCountData');
        if (menuPendingCountData) {
          v.handleMenuPendingData(menuPendingCountData)
        } else {
          handleData();
        }
      }

      function handleData() {
        v.axios.get(api.get_ymsDistributorCommon_getPendingCount).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              commonSessionStorage.setItem('menuPendingCountData', data);
              v.handleMenuPendingData(data)
            }
          }
        });
      }
    },
    // 处理菜单栏待处理数量的数据
    handleMenuPendingData(data) {
      let v = this;
      if (v.menuData.length > 0) {
        // 处理待处理数量
        function treeToList(tree, result = []) {
          tree.forEach(node => {
            result.push(node)
            node.children && treeToList(node.children, result)
          });
          return result
        }

        let newList = treeToList(v.menuData);
        if (newList.length > 0) {
          newList.map((item, index) => {
            for (let key in data) {
              if (item.menuKey === key) {
                v.$set(newList[index], 'quantity', data[key]);
              }
            }
          });
          v.$forceUpdate();
        }
      }
    }
  },
  watch: {
    $route: {
      handler(data) {
        let v = this;
        v.setMenuData(data.path);
      },
      deep: true,
      immediate: true
    },
    '$store.state.updateDistributorMenu': {
      handler(val) {
        let v = this;
        if (val) {
          v.activeName = localStorage.getItem('distributorActiveName');
          v.$nextTick(function () {
            v.$refs['leftMenu'].updateOpened();
            v.$refs['leftMenu'].updateActiveName();
          });
        }
      },
      deep: true
    },
    '$store.state.updatePendingCount': {
      handler(val) {
        if (val) {
          this.getMenuPendingData(true);
        }
      },
      deep: true
    }
  },
  components: {
    subMenu
  }
};
</script>
<style lang="less" scoped>

</style>
